/* Gooey-Feld (Tropfen aus der Pille).
   Gooey-Animation, eigene Arbeit von Moritz, für zeroLabs übernommen. Commit a71210a vom 02.10.2026.
   Steht in docs/anpassungen.md unter "Fremde Dateien im Theme".

   Geändert für zeroLabs (04.10.2026):
   - Alle Werte, die zeroLabs entscheidet (Maße, Farben, Zeiten, Physik), liest das Skript
     beim Start aus assets/zl-tokens.css (--zl-goo-*, --zl-control, --zl-icon, --zl-gap-element,
     --zl-ink, --zl-paper). Die Zahlen hier sind nur Rückfallwerte.
   - Die Werte werden bei jedem Start neu gelesen, und window.zlGoo erlaubt Neustart und
     Aufräumen. So können die Regler auf der Laborseite (?view=zl-newsletter) live wirken.
   - Ziel ist jedes Formular mit der Klasse .zl-newsletter, auf allen Seiten.
   - Antippen am Handy: Fokus ohne Springen der Seite (Stand 04.10.2026, touchFocusInPlace).
   - Offen ohne Fokus (28.10.2026): Trägt die Zeile data-goo-offen, bleibt die Kugel draußen, auch ohne Fokus und
     ohne Text. Das Ereignis zl:goo-sync an der Zeile lässt sie den Zustand neu lesen, die Kugel löst sich dann wie
     beim Antippen aus dem Feld (Passwortseite des Vorabzugangs, assets/zl-vorab.js).
   - Fertig (28.10.2026): window.zlGoo.fertig(zeile) macht aus dem Pfeil einen Haken und lässt die Kugel danach zurück ins
     Feld gehen. Nach einer Anmeldung (assets/zl-newsletter.js) und nach einem richtigen Code (assets/zl-vorab.js).
   Choreografie und Renderer (Keyframes, Signed Distance Field) sind unverändert. */
!(function () {
  // Liest einen Wert aus :root (Tokens). Gibt es die Variable nicht
  // (zum Beispiel im Shopify-Theme), gilt der Rückfallwert fb.
  const T = function (n, fb) {
      var v = getComputedStyle(document.documentElement)
          .getPropertyValue(n)
          .trim(),
        x = parseFloat(v);
      if (isNaN(x)) return fb;
      return /\ds$/.test(v) ? 1e3 * x : x;
    },
    STATE = [
      "sk-goo-body",
      "sk-goo-ready",
      "sk-goo-init",
      "sk-goo-open",
      "sk-goo-emerging",
      "sk-goo-merging",
      "sk-goo-closing",
      "sk-goo-pressing",
      "sk-goo-releasing",
      "sk-goo-impulse",
      "sk-goo-submitting",
    ],
    ANIM = [
      "sk-goo-emerging",
      "sk-goo-merging",
      "sk-goo-closing",
      "sk-goo-pressing",
      "sk-goo-releasing",
      "sk-goo-impulse",
      "sk-goo-submitting",
    ],
    store = (window.__SK_COMPOSE_UNDO__ = window.__SK_COMPOSE_UNDO__ || {});
  store.gooSubmit = store.gooSubmit || { cleanups: [] };
  // Werte aus zl-tokens.css, bei jedem Start neu gelesen (Laborregler).
  let CONTROLS_targets = ".zl-newsletter",
    CONTROLS_pagePath = "",
    CONTROLS_keepOpenWhenFilled = !0,
    CONTROLS_touchFocusInPlace = !0,
    CONTROLS_blobColor = "var(--zl-ink)",
    CONTROLS_textColor = "var(--zl-paper)",
    CONTROLS_emergeMs, CONTROLS_gooRadius, CONTROLS_popDelayMs, CONTROLS_wobble,
    CONTROLS_stretch, CONTROLS_snapWobble, CONTROLS_mergeMs, CONTROLS_mergeStretch,
    CONTROLS_fieldPull, CONTROLS_fieldRecoil, CONTROLS_fieldReach, CONTROLS_gapPx,
    CONTROLS_restScale, CONTROLS_btnSize, CONTROLS_arrowSize, CONTROLS_arrowStroke,
    CONTROLS_fieldPadPx, CONTROLS_fieldMaxWidth, CONTROLS_placeholderOpacity,
    CONTROLS_pressScale, CONTROLS_releaseScale, CONTROLS_pulseScale, CONTROLS_releaseMs;
  function readControls() {
    CONTROLS_popDelayMs = T("--zl-goo-delay", 320);
    CONTROLS_emergeMs = T("--zl-goo-out", 800);
    CONTROLS_mergeMs = T("--zl-goo-in", 800);
    CONTROLS_gooRadius = T("--zl-goo-radius", 14);
    CONTROLS_wobble = T("--zl-goo-wobble", 0.02);
    CONTROLS_stretch = T("--zl-goo-stretch", 0.5);
    CONTROLS_snapWobble = T("--zl-goo-snap", 0.05);
    CONTROLS_mergeStretch = T("--zl-goo-merge-stretch", 0.3);
    CONTROLS_fieldPull = T("--zl-goo-pull", 6);
    CONTROLS_fieldRecoil = T("--zl-goo-recoil", 3.5);
    CONTROLS_fieldReach = T("--zl-goo-reach", 5);
    CONTROLS_gapPx = T("--zl-gap-element", 12);
    CONTROLS_restScale = T("--zl-goo-rest-scale", 0.4);
    CONTROLS_btnSize = T("--zl-control", 48);
    CONTROLS_arrowSize = T("--zl-icon", 24);
    CONTROLS_arrowStroke = T("--zl-goo-stroke", 2.25);
    CONTROLS_fieldPadPx = T("--zl-space-4", 24);
    CONTROLS_fieldMaxWidth = T("--zl-goo-field-rest", 360);
    CONTROLS_placeholderOpacity = T("--zl-goo-placeholder", 0.8);
    CONTROLS_pressScale = T("--zl-goo-press", 1.14);
    CONTROLS_releaseScale = T("--zl-goo-release", 0.94);
    CONTROLS_pulseScale = T("--zl-goo-pulse", 1.06);
    CONTROLS_releaseMs = T("--zl-goo-hold", 350);
  }
  const reduce = window.matchMedia
    ? window.matchMedia("(prefers-reduced-motion: reduce)")
    : { matches: !1 };
  function force(el, map) {
    if (!el) return function () {};
    const prev = el.getAttribute("style");
    return (
      Object.keys(map).forEach(function (k) {
        el.style.setProperty(k, map[k], "important");
      }),
      function () {
        null === prev
          ? el.removeAttribute("style")
          : el.setAttribute("style", prev);
      }
    );
  }
  function ell(px, py, cx, cy, a, b) {
    if (a <= 0 || b <= 0) return 1e9;
    const x = px - cx,
      y = py - cy,
      k0 = Math.sqrt((x * x) / (a * a) + (y * y) / (b * b)),
      k1 = Math.sqrt((x * x) / (a * a * a * a) + (y * y) / (b * b * b * b));
    return k1 > 0 ? (k0 * (k0 - 1)) / k1 : -Math.min(a, b);
  }
  function smin(a, b, k) {
    const m = a < b ? a : b;
    if (k <= 0) return m;
    const h = Math.max(k - Math.abs(a - b), 0) / k;
    return m - h * h * k * 0.25;
  }
  function setup(body) {
    if (body.__skGoo) return;
    const input = body.querySelector(".newsletter-form-field-element"),
      btn = body.querySelector(".newsletter-form-button");
    if (!input || !btn) return;
    const form = body.closest("form"),
      fieldWrap = input.closest(".newsletter-form-field-wrapper"),
      btnWrap = btn.closest(".newsletter-form-button-wrapper");
    body.classList.add("sk-goo-body", "sk-goo-init");
    let iconSpan = btn.querySelector(".newsletter-form-button-icon"),
      iconMade = !1;
    iconSpan ||
      ((iconSpan = document.createElement("span")),
      (iconSpan.className = "newsletter-form-button-icon"),
      btn.appendChild(iconSpan),
      (iconMade = !0));
    const prevIcon = iconSpan.innerHTML,
      prevIconStyle = iconSpan.getAttribute("style"),
      prevAria = btn.getAttribute("aria-label"),
      labelEl = btn.querySelector(".newsletter-form-button-label"),
      labelText = (labelEl ? labelEl.textContent : "").trim() || "Subscribe";
    ((iconSpan.innerHTML =
      '<svg class="sk-goo-arrow" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M5 12h13" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"/><path d="M13 6.5l5.5 5.5-5.5 5.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"/></svg>'),
      btn.setAttribute("aria-label", labelText));
    const restoreInput = force(input, {
        "padding-left": "var(--sk-goo-pad)",
        "padding-right": "var(--sk-goo-pad)",
        "border-radius": "999px",
        width: "100%",
        "max-width": "none",
        background: "transparent",
        border: "0",
        "box-shadow": "none",
      }),
      restoreBtn = force(btn, {
        padding: "0",
        margin: "0",
        width: "var(--sk-goo-btn)",
        height: "var(--sk-goo-btn)",
        "min-width": "0",
        "min-height": "0",
        "border-radius": "999px",
        background: "transparent",
        border: "0",
        "box-shadow": "none",
      }),
      restoreWrap = force(fieldWrap, {
        padding: "0",
        margin: "0",
        width: "100%",
      }),
      layer = document.createElement("div");
    layer.className = "sk-goo-layer";
    const fieldBlob = document.createElement("div");
    ((fieldBlob.className = "sk-goo-blob sk-goo-blob--field"),
      (fieldBlob.innerHTML =
        '<div class="sk-goo-skin"><div class="sk-goo-cap"></div></div>'));
    const btnBlob = document.createElement("div");
    ((btnBlob.className = "sk-goo-blob sk-goo-blob--btn"),
      (btnBlob.innerHTML = '<div class="sk-goo-skin"></div>'),
      layer.appendChild(fieldBlob),
      layer.appendChild(btnBlob));
    const fieldSkin = fieldBlob.firstElementChild,
      cap = fieldSkin.firstElementChild,
      btnSkin = btnBlob.firstElementChild,
      canvas = document.createElement("canvas");
    ((canvas.className = "sk-goo-canvas"),
      canvas.setAttribute("aria-hidden", "true"));
    const ctx = canvas.getContext("2d");
    (body.insertBefore(layer, body.firstChild),
      body.insertBefore(canvas, layer.nextSibling));
    const props = {
      "--sk-goo-color": CONTROLS_blobColor,
      "--sk-goo-text": CONTROLS_textColor,
      "--sk-goo-emerge": CONTROLS_emergeMs + "ms",
      "--sk-goo-pop": CONTROLS_popDelayMs + "ms",
      "--sk-goo-wobble": String(CONTROLS_wobble),
      "--sk-goo-stretch": String(CONTROLS_stretch),
      "--sk-goo-snap": String(CONTROLS_snapWobble),
      "--sk-goo-merge": CONTROLS_mergeMs + "ms",
      "--sk-goo-merge-stretch": String(CONTROLS_mergeStretch),
      "--sk-goo-pull": String(CONTROLS_fieldPull),
      "--sk-goo-recoil": String(CONTROLS_fieldRecoil),
      "--sk-goo-reach": String(CONTROLS_fieldReach),
      "--sk-goo-rest-scale": String(CONTROLS_restScale),
      "--sk-goo-gap": CONTROLS_gapPx + "px",
      "--sk-goo-btn": CONTROLS_btnSize + "px",
      "--sk-goo-arrow": CONTROLS_arrowSize + "px",
      "--sk-goo-arrow-stroke": String(CONTROLS_arrowStroke),
      "--sk-goo-pad": CONTROLS_fieldPadPx + "px",
      "--sk-goo-max": CONTROLS_fieldMaxWidth + "px",
      "--sk-goo-ph": String(CONTROLS_placeholderOpacity),
      "--sk-goo-press": String(CONTROLS_pressScale),
      "--sk-goo-release-scale": String(CONTROLS_releaseScale),
      "--sk-goo-pulse-scale": String(CONTROLS_pulseScale),
      "--sk-goo-impulse-scale": "1.015",
    };
    Object.keys(props).forEach(function (k) {
      body.style.setProperty(k, props[k]);
    });
    const timers = [],
      rafs = [],
      pinned = [];
    function later(fn, ms) {
      const id = setTimeout(fn, ms);
      return (timers.push(id), id);
    }
    function clearTimers() {
      for (; timers.length; ) clearTimeout(timers.pop());
    }
    function pin(fn, ms) {
      const id = setTimeout(fn, ms);
      return (pinned.push(id), id);
    }
    function offsetIn(el) {
      let x = 0,
        y = 0,
        n = el;
      for (; n && n !== body && body.contains(n); )
        ((x += n.offsetLeft), (y += n.offsetTop), (n = n.offsetParent));
      return { x: x, y: y };
    }
    let rgb = [255, 255, 255, 1],
      fill = "rgba(255,255,255,1)",
      lastArrow = "",
      rafId = 0,
      lastActive = 0;
    function draw() {
      if (!ctx) return;
      const br = body.getBoundingClientRect();
      if (!br.width || !br.height) return;
      const dpr = Math.min(3, window.devicePixelRatio || 1),
        cw = Math.round((br.width + 48) * dpr),
        ch = Math.round((br.height + 32) * dpr);
      (canvas.width === cw && canvas.height === ch) ||
        ((canvas.width = cw), (canvas.height = ch));
      const ox = br.left - 24,
        oy = br.top - 16;
      function rel(el) {
        const r = el.getBoundingClientRect();
        return { x: r.left - ox, y: r.top - oy, w: r.width, h: r.height };
      }
      const F = rel(fieldSkin),
        C = rel(cap),
        B = rel(btnSkin),
        T = rel(btn);
      if (
        (ctx.setTransform(1, 0, 0, 1, 0, 0),
        ctx.clearRect(0, 0, cw, ch),
        !F.w || !F.h)
      )
        return;
      const ax = B.x + B.w / 2 - (T.x + T.w / 2),
        ay = B.y + B.h / 2 - (T.y + T.h / 2),
        arrowT = "translate(" + ax.toFixed(2) + "px," + ay.toFixed(2) + "px)";
      arrowT !== lastArrow &&
        ((lastArrow = arrowT), (iconSpan.style.transform = arrowT));
      const fr = F.x + F.w,
        r = F.h / 2,
        outside = B.x + B.w - fr,
        open = body.classList.contains("sk-goo-open"),
        useBall =
          outside > 0 && B.w > 0 && B.h > 0 && (!reduce.matches || open),
        k = CONTROLS_gooRadius * (0.3 + 0.7 * Math.min(1, outside / 12)),
        useCap = C.w > 0 && C.h > 0 && C.x + C.w > fr + 0.05;
      let x0 = fr - F.h - 2,
        x1 = fr + 2,
        y0 = F.y - 2,
        y1 = F.y + F.h + 2;
      (useCap &&
        ((x1 = Math.max(x1, C.x + C.w + 2)),
        (y0 = Math.min(y0, C.y - 2)),
        (y1 = Math.max(y1, C.y + C.h + 2))),
        useBall &&
          ((x0 = Math.min(x0, B.x - k - 2)),
          (x1 = Math.max(x1, B.x + B.w + k + 2)),
          (y0 = Math.min(y0, B.y - k - 2)),
          (y1 = Math.max(y1, B.y + B.h + k + 2))));
      const X0 = Math.max(0, Math.floor(x0 * dpr)),
        X1 = Math.min(cw, Math.ceil(x1 * dpr)),
        Y0 = Math.max(0, Math.floor(y0 * dpr)),
        Y1 = Math.min(ch, Math.ceil(y1 * dpr));
      ((ctx.fillStyle = fill),
        X0 > 0 &&
          (ctx.save(),
          ctx.beginPath(),
          ctx.rect(0, 0, X0, ch),
          ctx.clip(),
          ctx.scale(dpr, dpr),
          (function (c, R) {
            const r = Math.min(R.h / 2, R.w / 2),
              x = R.x,
              y = R.y,
              w = R.w,
              h = R.h;
            (c.beginPath(),
              c.moveTo(x + r, y),
              c.lineTo(x + w - r, y),
              c.arc(x + w - r, y + h / 2, r, -Math.PI / 2, Math.PI / 2),
              c.lineTo(x + r, y + h),
              c.arc(x + r, y + h / 2, r, Math.PI / 2, 1.5 * Math.PI),
              c.closePath());
          })(ctx, F),
          ctx.fill(),
          ctx.restore()));
      const W = X1 - X0,
        H = Y1 - Y0;
      if (W <= 0 || H <= 0) return;
      const img = ctx.createImageData(W, H),
        d8 = img.data,
        axF = F.x + r,
        bxF = Math.max(axF, fr - r),
        cyF = F.y + r,
        ccx = C.x + C.w / 2,
        ccy = C.y + C.h / 2,
        ca = C.w / 2,
        cb = C.h / 2,
        bcx = B.x + B.w / 2,
        bcy = B.y + B.h / 2,
        ba = B.w / 2,
        bb = B.h / 2,
        R = rgb[0],
        G = rgb[1],
        Bl = rgb[2],
        A = 255 * rgb[3];
      for (let j = 0; j < H; j++) {
        const py = (Y0 + j + 0.5) / dpr,
          dyf = py - cyF;
        for (let i = 0; i < W; i++) {
          const px = (X0 + i + 0.5) / dpr,
            dxf = px - (px < axF ? axF : px > bxF ? bxF : px);
          let d = Math.sqrt(dxf * dxf + dyf * dyf) - r;
          if (useCap) {
            const dc = ell(px, py, ccx, ccy, ca, cb);
            dc < d && (d = dc);
          }
          useBall && (d = smin(d, ell(px, py, bcx, bcy, ba, bb), k));
          let a = 0.5 - d * dpr;
          if (a > 0) {
            a > 1 && (a = 1);
            const o = 4 * (j * W + i);
            ((d8[o] = R),
              (d8[o + 1] = G),
              (d8[o + 2] = Bl),
              (d8[o + 3] = a * A));
          }
        }
      }
      ctx.putImageData(img, X0, Y0);
    }
    function loop() {
      ((rafId = 0), draw());
      const now = performance.now();
      ((function () {
        for (let i = 0; i < ANIM.length; i++)
          if (body.classList.contains(ANIM[i])) return !0;
        return !1;
      })() && (lastActive = now),
        now - lastActive < 150 && (rafId = requestAnimationFrame(loop)));
    }
    function kick() {
      ((lastActive = performance.now()),
        rafId || (rafId = requestAnimationFrame(loop)));
    }
    function measure() {
      const fw = input.offsetWidth,
        fh = input.offsetHeight;
      if (!fw || !btn.offsetWidth) return;
      const f = offsetIn(input),
        b = offsetIn(btn);
      ((fieldBlob.style.left = f.x + "px"),
        (fieldBlob.style.top = f.y + "px"),
        (fieldBlob.style.width = fw + "px"),
        (fieldBlob.style.height = fh + "px"),
        (btnBlob.style.left = b.x + "px"),
        (btnBlob.style.top = b.y + "px"),
        (btnBlob.style.width = btn.offsetWidth + "px"),
        (btnBlob.style.height = btn.offsetHeight + "px"),
        (cap.style.width = fh + "px"),
        (rgb = (function (str) {
          const m = /rgba?\(([^)]+)\)/.exec(str || "");
          if (!m) return [255, 255, 255, 1];
          const p = m[1]
            .split(/[\s,\/]+/)
            .filter(Boolean)
            .map(parseFloat);
          return [p[0] || 0, p[1] || 0, p[2] || 0, isNaN(p[3]) ? 1 : p[3]];
        })(getComputedStyle(fieldSkin).backgroundColor)),
        (fill =
          "rgba(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + "," + rgb[3] + ")"),
        kick());
    }
    let isOpen = !1,
      seqBusy = !1,
      pending = !1;
    function wanted() {
      const focused = body.contains(document.activeElement),
        filled = CONTROLS_keepOpenWhenFilled && !!input.value.trim(),
        offen = body.hasAttribute("data-goo-offen");
      return focused || filled || offen;
    }
    function settle() {
      ((seqBusy = !1), pending && ((pending = !1), sync()));
    }
    function sync(silent) {
      if (!0 === silent)
        return (
          (isOpen = wanted()),
          clearTimers(),
          (seqBusy = !1),
          (pending = !1),
          body.classList.remove(
            "sk-goo-emerging",
            "sk-goo-merging",
            "sk-goo-closing",
          ),
          body.classList.toggle("sk-goo-open", isOpen),
          void kick()
        );
      if (seqBusy) return void (pending = !0);
      const want = wanted();
      want !== isOpen &&
        ((isOpen = want),
        clearTimers(),
        (seqBusy = !0),
        want
          ? (body.classList.remove(
              "sk-goo-merging",
              "sk-goo-closing",
              "sk-goo-emerging",
            ),
            body.offsetWidth,
            body.classList.add("sk-goo-open", "sk-goo-emerging"),
            later(
              function () {
                (body.classList.remove("sk-goo-emerging"), settle());
              },
              CONTROLS_popDelayMs + CONTROLS_emergeMs + 40,
            ))
          : (body.classList.remove("sk-goo-emerging"),
            body.classList.add("sk-goo-closing"),
            later(function () {
              (body.classList.remove(
                "sk-goo-open",
                "sk-goo-closing",
                "sk-goo-merging",
              ),
                body.offsetWidth,
                body.classList.add("sk-goo-merging"),
                later(function () {
                  (body.classList.remove("sk-goo-merging"), settle());
                }, CONTROLS_mergeMs + 40));
            }, 100)),
        kick());
    }
    let pressing = !1,
      pressedAt = 0,
      armed = !1,
      bypass = !1;
    function doRelease() {
      (body.classList.remove("sk-goo-pressing"),
        body.classList.add("sk-goo-releasing"),
        later(function () {
          body.classList.remove("sk-goo-releasing");
        }, 700),
        later(function () {
          (body.classList.add("sk-goo-impulse"),
            later(function () {
              body.classList.remove("sk-goo-impulse");
            }, 280));
        }, 60),
        kick());
    }
    function onDown() {
      ((pressing = !0),
        (pressedAt = Date.now()),
        body.classList.remove("sk-goo-releasing"),
        body.classList.add("sk-goo-pressing"),
        kick());
    }
    function onUp() {
      if (!pressing) return;
      pressing = !1;
      const held = Date.now() - pressedAt,
        wait = Math.max(0, 120 - held);
      wait > 0 ? later(doRelease, wait) : doRelease();
    }
    function startSubmit() {
      armed ||
        ((armed = !0),
        Date.now() - pressedAt > 800 && (onDown(), pin(onUp, 120)),
        pin(function () {
          ((armed = !1), (bypass = !0));
          try {
            btn.click();
          } finally {
            bypass = !1;
          }
        }, CONTROLS_releaseMs));
    }
    function onClick(e) {
      bypass ||
        (e.preventDefault(), e.stopImmediatePropagation(), startSubmit());
    }
    function onKey(e) {
      "Enter" !== e.key || e.isComposing || (e.preventDefault(), startSubmit());
    }
    // Antippen am Handy: Fokus ohne Springen der Seite, erst scrollen, wenn die Tastatur das Feld verdeckt
    // (Stand 04.10.2026).
    let touchX = 0,
      touchY = 0,
      touchOk = !1,
      vvCheck = null;
    function dropVvCheck() {
      vvCheck &&
        window.visualViewport &&
        window.visualViewport.removeEventListener("resize", vvCheck);
      vvCheck = null;
    }
    function onTouchStart(e) {
      const t = e.changedTouches && e.changedTouches[0];
      t ? ((touchX = t.clientX), (touchY = t.clientY), (touchOk = !0)) : (touchOk = !1);
    }
    function onTouchEnd(e) {
      if (!CONTROLS_touchFocusInPlace || !touchOk) return;
      if (((touchOk = !1), document.activeElement === input)) return;
      if (!e.cancelable) return;
      const t = e.changedTouches && e.changedTouches[0];
      if (t && (Math.abs(t.clientX - touchX) > 10 || Math.abs(t.clientY - touchY) > 10)) return;
      e.preventDefault();
      try {
        input.focus({ preventScroll: !0 });
      } catch (err) {
        input.focus();
      }
      if (document.activeElement !== input) return;
      dropVvCheck();
      const check = function () {
        vvCheck === check &&
          (dropVvCheck(),
          (function () {
            const vv = window.visualViewport,
              r = input.getBoundingClientRect(),
              top = vv ? vv.offsetTop : 0,
              bottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
            if (r.bottom > bottom || r.top < top)
              try {
                input.scrollIntoView({ block: "nearest", inline: "nearest" });
              } catch (err) {
                input.scrollIntoView(!1);
              }
          })());
      };
      ((vvCheck = check),
        window.visualViewport && window.visualViewport.addEventListener("resize", check),
        pin(check, 700));
    }
    function checkSubmitting() {
      const busy =
          (form && form.classList.contains("submitting")) ||
          btn.classList.contains("submitting") ||
          !0 === btn.disabled,
        had = body.classList.contains("sk-goo-submitting");
      (body.classList.toggle("sk-goo-submitting", !!busy),
        had !== !!busy && kick());
    }
    const onInput = function () {
        sync();
      },
      onFocusIn = function () {
        sync();
      },
      onZlSync = function () {
        sync();
      },
      onFocusOut = function () {
        later(function () {
          sync();
        }, 0);
      };
    (body.addEventListener("focusin", onFocusIn),
      body.addEventListener("focusout", onFocusOut),
      body.addEventListener("zl:goo-sync", onZlSync),
      input.addEventListener("input", onInput),
      input.addEventListener("blur", onInput),
      input.addEventListener("keydown", onKey),
      input.addEventListener("touchstart", onTouchStart, { passive: !0 }),
      input.addEventListener("touchend", onTouchEnd, { passive: !1 }),
      btn.addEventListener("click", onClick, !0),
      btn.addEventListener("pointerdown", onDown),
      btn.addEventListener("pointerup", onUp),
      btn.addEventListener("pointercancel", onUp),
      window.addEventListener("pointerup", onUp),
      window.addEventListener("pointercancel", onUp),
      window.addEventListener("resize", measure));
    let ro = null;
    window.ResizeObserver &&
      ((ro = new ResizeObserver(measure)),
      ro.observe(body),
      fieldWrap && ro.observe(fieldWrap),
      btnWrap && ro.observe(btnWrap),
      ro.observe(input));
    let mo = null;
    (window.MutationObserver &&
      form &&
      ((mo = new MutationObserver(function (records) {
        let relevant = !1;
        for (let i = 0; i < records.length; i++) {
          const t = records[i].target;
          if (t !== iconSpan && t !== canvas && !layer.contains(t)) {
            relevant = !0;
            break;
          }
        }
        relevant && (checkSubmitting(), measure());
      })),
      mo.observe(form, {
        attributes: !0,
        childList: !0,
        subtree: !0,
        attributeFilter: ["class", "disabled", "style"],
      })),
      measure(),
      sync(!0),
      checkSubmitting(),
      rafs.push(
        requestAnimationFrame(function () {
          (measure(),
            body.classList.add("sk-goo-ready"),
            rafs.push(
              requestAnimationFrame(function () {
                (body.classList.remove("sk-goo-init"), kick());
              }),
            ));
        }),
      ),
      later(measure, 400),
      (body.__skGoo = !0),
      store.gooSubmit.cleanups.push(function () {
        for (
          clearTimers(),
            (function () {
              for (; pinned.length; ) clearTimeout(pinned.pop());
            })(),
            dropVvCheck();
          rafs.length;
        )
          cancelAnimationFrame(rafs.pop());
        (rafId && cancelAnimationFrame(rafId),
          (rafId = 0),
          body.removeEventListener("focusin", onFocusIn),
          body.removeEventListener("focusout", onFocusOut),
          body.removeEventListener("zl:goo-sync", onZlSync),
          input.removeEventListener("input", onInput),
          input.removeEventListener("blur", onInput),
          input.removeEventListener("keydown", onKey),
          input.removeEventListener("touchstart", onTouchStart),
          input.removeEventListener("touchend", onTouchEnd),
          btn.removeEventListener("click", onClick, !0),
          btn.removeEventListener("pointerdown", onDown),
          btn.removeEventListener("pointerup", onUp),
          btn.removeEventListener("pointercancel", onUp),
          window.removeEventListener("pointerup", onUp),
          window.removeEventListener("pointercancel", onUp),
          window.removeEventListener("resize", measure),
          ro && ro.disconnect(),
          mo && mo.disconnect(),
          layer.parentNode && layer.parentNode.removeChild(layer),
          canvas.parentNode && canvas.parentNode.removeChild(canvas),
          iconMade
            ? iconSpan.parentNode && iconSpan.parentNode.removeChild(iconSpan)
            : ((iconSpan.innerHTML = prevIcon),
              null === prevIconStyle
                ? iconSpan.removeAttribute("style")
                : iconSpan.setAttribute("style", prevIconStyle)),
          null === prevAria
            ? btn.removeAttribute("aria-label")
            : btn.setAttribute("aria-label", prevAria),
          restoreInput(),
          restoreBtn(),
          restoreWrap(),
          STATE.forEach(function (c) {
            body.classList.remove(c);
          }),
          Object.keys(props).forEach(function (p) {
            body.style.removeProperty(p);
          }),
          body.getAttribute("style") || body.removeAttribute("style"),
          delete body.__skGoo);
      }));
  }
  function run() {
    if (
      !(function () {
        const p = (CONTROLS_pagePath || "").trim();
        return (
          !p ||
          (location.pathname.replace(/\/+$/, "") || "/") ===
            (p.replace(/\/+$/, "") || "/")
        );
      })()
    )
      return;
    const sel = (CONTROLS_targets || "").trim();
    if (!sel) return;
    let roots = [];
    try {
      roots = Array.prototype.slice.call(document.querySelectorAll(sel));
    } catch (e) {
      return;
    }
    roots.length &&
      roots.forEach(function (root) {
        (root.matches(".newsletter-form-body")
          ? [root]
          : Array.prototype.slice.call(
              root.querySelectorAll(".newsletter-form-body"),
            )
        ).forEach(setup);
      });
  }
  function start() {
    readControls();
    run();
  }
  // Fertig (28.10.2026): Ist etwas angekommen (Anmeldung, richtiger Code), wird der Pfeil in der Kugel zum Haken, der Text
  // im Feld blendet aus, und nach einem Halt geht die Kugel zurück ins Feld wie beim Verlassen eines leeren Felds.
  // Gibt ein Promise zurück, das erfüllt ist, wenn die Kugel wieder im Feld steht. Bei reduzierter Bewegung sofort.
  // Mit meldung steht danach dieser Text mittig im Feld und bleibt stehen; das Promise liefert
  // dann eine Funktion, die Feld und Meldung wieder in den Ausgangszustand bringt (für das Labor).
  // Pfeil: Schaft (5,12) bis (18,12), Spitze um (18.5,12). Haken: kurzer Strich (5.5,12.5) bis (10,17), langer Strich
  // (10,17) über (14.25,12.25) bis (18.5,7.5). Zwischen beiden laufen Punkte, Längen und Winkel gleichmäßig mit.
  function fertig(body, meldung) {
    return new Promise(function (resolve) {
      if (!body) return resolve(function () {});
      const input = body.querySelector("input:not([type=hidden])"),
        paths = body.querySelectorAll(".sk-goo-arrow path"),
        still =
          window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      // Meldung im Feld: mittig im Feld, in Schrift und Farbe der Eingabe, blendet ein (Moritz, 28.10.2026).
      const zeigeMeldung = function () {
        if (!meldung || !input) return null;
        const cs = getComputedStyle(input),
          huelle = input.parentElement;
        "static" === getComputedStyle(huelle).position &&
          (huelle.style.position = "relative");
        const m = document.createElement("span");
        m.className = "zl-goo-meldung";
        m.setAttribute("role", "status");
        m.textContent = meldung;
        Object.assign(m.style, {
          position: "absolute",
          left: input.offsetLeft + "px",
          top: input.offsetTop + "px",
          width: input.offsetWidth + "px",
          height: input.offsetHeight + "px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxSizing: "border-box",
          paddingLeft: cs.paddingLeft,
          paddingRight: cs.paddingRight,
          font: cs.font,
          letterSpacing: cs.letterSpacing,
          color: cs.color,
          pointerEvents: "none",
          whiteSpace: "nowrap",
        });
        input.style.opacity = "0";
        huelle.appendChild(m);
        still ||
          !m.animate ||
          m.animate([{ opacity: 0 }, { opacity: 1 }], {
            duration: T("--zl-goo-haken", 500),
            easing: "ease-out",
          });
        return function () {
          (m.remove(), (input.style.opacity = ""));
        };
      };
      if (still || paths.length < 2) {
        input && (input.value = "");
        body.removeAttribute("data-goo-offen");
        const weg = zeigeMeldung();
        return resolve(weg || function () {});
      }
      const dur = T("--zl-goo-haken", 500),
        halt = T("--zl-goo-haken-halt", 600),
        alt = [paths[0].getAttribute("d"), paths[1].getAttribute("d")],
        mix = function (a, b, e) {
          return a + (b - a) * e;
        },
        rad = Math.PI / 180,
        punkt = function (x, y, w, l) {
          return [x + l * Math.cos(w * rad), y + l * Math.sin(w * rad)];
        },
        f = function (n) {
          return Math.round(n * 1e3) / 1e3;
        },
        zeichnen = function (e) {
          const sx = mix(5, 5.5, e),
            sy = mix(12, 12.5, e),
            s2 = punkt(sx, sy, mix(0, 45, e), mix(13, 6.364, e)),
            px = mix(18.5, 14.25, e),
            py = mix(12, 12.25, e),
            l = mix(7.778, 6.374, e),
            a = punkt(px, py, mix(-135, -48.18, e), l),
            b = punkt(px, py, mix(135, 131.82, e), l);
          (paths[0].setAttribute(
            "d",
            "M" + f(sx) + " " + f(sy) + "L" + f(s2[0]) + " " + f(s2[1]),
          ),
            paths[1].setAttribute(
              "d",
              "M" + f(a[0]) + " " + f(a[1]) + "L" + f(px) + " " + f(py) +
                "L" + f(b[0]) + " " + f(b[1]),
            ));
        },
        sanft = function (t) {
          return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
        };
      body.classList.add("zl-goo-fertig");
      const ausblenden =
        input && input.animate
          ? input.animate([{ opacity: 1 }, { opacity: 0 }], {
              duration: dur,
              easing: "ease-out",
              fill: "forwards",
            })
          : null;
      const t0 = performance.now();
      const schritt = function (t) {
        const p = Math.min(1, (t - t0) / dur);
        zeichnen(sanft(p));
        p < 1 ? requestAnimationFrame(schritt) : setTimeout(zurueck, halt);
      };
      requestAnimationFrame(schritt);
      // Kugel zurück ins Feld: leer, ohne Fokus, nicht mehr offen gehalten.
      function zurueck() {
        input && (input.value = "");
        body.removeAttribute("data-goo-offen");
        const a = document.activeElement;
        a && body.contains(a) && a.blur && a.blur();
        body.dispatchEvent(new CustomEvent("zl:goo-sync"));
        const ende = performance.now() + 3e3;
        const warten = function () {
          const unterwegs =
            body.classList.contains("sk-goo-open") ||
            body.classList.contains("sk-goo-closing") ||
            body.classList.contains("sk-goo-merging");
          if (unterwegs && performance.now() < ende)
            return void requestAnimationFrame(warten);
          (paths[0].setAttribute("d", alt[0]),
            paths[1].setAttribute("d", alt[1]),
            body.classList.remove("zl-goo-fertig"));
          const weg = zeigeMeldung();
          ausblenden && ausblenden.cancel();
          resolve(weg || function () {});
        };
        requestAnimationFrame(warten);
      }
    });
  }
  // Neustart und Aufräumen, für die Laborregler.
  window.zlGoo = {
    restart: function () {
      store.gooSubmit.cleanups.splice(0).forEach(function (fn) {
        fn();
      });
      start();
    },
    fertig: fertig,
  };
  "loading" !== document.readyState
    ? start()
    : document.addEventListener("DOMContentLoaded", start);
})();
